export default __webpack_public_path__ + "static/media/soren.e0011512.jpg";